import React, { useEffect, useState, useRef } from "react";
import Box from "@mui/material/Box";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import addProduct from "../../utils/addProducts.png";
import deleteIcon from "../../utils/delete.png";
import Tooltip from "@mui/material/Tooltip";
import notAllowedSymbol from "../../utils/notAllowedSymbol.svg";
import { TextField, Autocomplete } from "@mui/material";

const ProductsInfo = ({
  productEntryInAllEntries,
  clearProductsList,
  setProductEntries,
  productEntries,
  handleAddRow,
  handleInputChange,
  selectProduct,
  currentProductEntryRowId,
  productData,
  setCurrentF2ItemForSearchPopup,
  rowInputRefs,
  qtyInputRefsFromParent,
  
}) => {
  const [pendingQtyFocus, setPendingQtyFocus] = useState(null);
  const containerRef = useRef(null);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const listboxRef = useRef(null);

  const API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";
  const imageApiPath = API_PATHS[0]?.IMG_API_PATH;

  const qtyInputRefs = useRef({});
  const priceInputRefs = useRef({}); // Add this near your other refs

  const [selectedRows, setSelectedRows] = useState([]);

  const [isSelectedItemCodeCorrect, setIsSelectedItemCodeCorrect] =
    useState(false);

  const toggleSelectAll = () => {
    if (selectedRows?.length === productEntries?.length) {
      setSelectedRows([]); // Unselect all if all are selected
    } else {
      setSelectedRows(productEntries?.map((_, index) => index)); // Select all rows
    }
  };

  // Toggle selection of a row
  const toggleRowSelection = (index) => {
    setSelectedRows(
      (prevSelectedRows) =>
        prevSelectedRows.includes(index)
          ? prevSelectedRows.filter((i) => i !== index) // Remove if already selected
          : [...prevSelectedRows, index] // Add if not selected
    );
  };

  // Delete selected rows
  const deleteSelectedRows = () => {
    const updatedEntries = productEntries.filter(
      (_, index) => !selectedRows.includes(index)
    );
    setProductEntries(updatedEntries);
    setSelectedRows([]); // Clear selection after deletion
  };

  const productsWithImage = productData?.filter(
    (prod) => prod.Imagepath !== ""
  );
  const imagePaths = productsWithImage?.map((prod) => prod.Imagepath);
  // console.log('productsWithImage',productsWithImage)
  // console.log('imagePaths',imagePaths)

  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getStyleOfChip = () => {
    return "inline-flex items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset";
  };

  const fetchItemImage = (itemFilePath) => {
    if (!itemFilePath) return ""; // Handle missing image

    // Extract file name from the full path
    const extractedFileName = itemFilePath.split("BONDTIME_PRODUCT_IMG\\")[1];

    // Construct the correct URL for the image
    return `${imageApiPath}/BONDTIME_PRODUCT_IMG/${extractedFileName}`;
  };

  const TableListboxComponent = React.forwardRef(function ListboxComponent(
    props,
    ref
  ) {
    const { children, ...other } = props;
    return (
      <div
        ref={(node) => {
          listboxRef.current = node;
          if (typeof ref === "function") {
            ref(node);
          } else if (ref) {
            ref.current = node;
          }
        }}
        {...other}
        className="max-h-[400px] overflow-auto"
      >
        <table className="w-full border-collapse table-fixed bg-white">
          <thead className="sticky top-0 bg-gray-100 z-10 shadow-sm">
            <tr className="text-[11px] uppercase text-gray-600 border-b">
              <th className="p-2 text-left w-[20%]">Code</th>
              <th className="p-2 text-left w-[20%]">Description</th>
              <th className="p-2 text-center w-[6%]">Unit</th>
              <th className="p-2 text-center w-[7%]">Category</th>
              <th className="p-2 text-center w-[7%]">Total Stock</th>
              <th className="p-2 text-center w-[7%]">Br Stock</th>

              <th className="p-2 text-center w-[10%]">Group</th>
              <th className="p-2 text-center w-[8%]">Sub Group</th>
              <th className="p-2 text-center w-[15%]">Price</th>
            </tr>
          </thead>
          <tbody className="text-sm">{children}</tbody>
        </table>
      </div>
    );
  });

  useEffect(() => {
    if (highlightedIndex >= 0 && listboxRef.current) {
      const rows = listboxRef.current.querySelectorAll("tbody tr");
      const highlightedRow = rows[highlightedIndex];

      if (highlightedRow) {
        highlightedRow.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }
    }
  }, [highlightedIndex]);

  // Add this useEffect
  useEffect(() => {
    if (pendingQtyFocus && qtyInputRefs.current[pendingQtyFocus]) {
      qtyInputRefs.current[pendingQtyFocus].focus();
      qtyInputRefs.current[pendingQtyFocus].select();
      setPendingQtyFocus(null);
    }
  }, [productEntries, pendingQtyFocus]); // fires AFTER re-render

  return (
    <div className="productsContainer rounded py-4  min-h-[300px]">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-thin">Products Of Interest</h2>
        <div className="flex gap-2">
          <button
            type="button"
            className="px-3 py-1 text-xs font-medium text-white bg-green-600 rounded hover:bg-green-700 transition-colors mt-2"
            onClick={(e) => handleAddRow(e)}
          >
            <span>Add +</span>
          </button>
          {/* <button
            className={`p-2 ${selectedRows?.length === 0 ? "invisible" : ""}`}
            onClick={(e)=>handleDeleteSelected(e)}
          >
            <img src={deleteIcon} alt="delete-icon" className="w-4 h-4" />
          </button> */}
        </div>
      </div>
      <div ref={containerRef} className="overflow-x-auto min-h-[220px]">
        {selectedRows?.length > 0 && (
          <button
            onClick={deleteSelectedRows}
            disabled={selectedRows?.length === 0}
            className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600 mb-2"
          >
            Delete Selected
          </button>
        )}
        <table className="min-w-full bg-white border border-gray-300   ">
          <thead className="">
            <tr className="bg-gray-200  rounded">
              <th className="border px-2 py-1 text-center">
                <input
                  className="rounded border border-sm shadow"
                  type="checkbox"
                  onChange={toggleSelectAll}
                  checked={
                    selectedRows?.length === productEntries?.length &&
                    productEntries?.length > 0
                  }
                />
              </th>
              <th className="px-1 py-0.5 font-normal border">Item Code</th>
              <th className="px-1 py-0.5 font-normal w-[300px]  border">
                Description
              </th>
              <th className="px-1 py-0.5 font-normal border">Image</th>
              <th className="px-1 py-0.5 font-normal border">Unit</th>
              <th className="px-1 py-0.5 font-normal border">Curr Stock</th>
              <th className="px-1 py-0.5 font-normal border">Qty</th>
              <th className="px-1 py-0.5 font-normal border">Price</th>
              <th className="px-1 py-0.5 font-normal border">Amnt</th>
            </tr>
          </thead>

          <tbody>
            {productEntries?.map((row, index) => (
              <tr key={index} className="text-sm">
                {console.log(
                  "productEntries in tabel: currentProductEntryRowId",
                  productEntries,
                  currentProductEntryRowId
                )}

                <td className=" border w-[20px]  text-center">
                  <input
                    type="checkbox"
                    className="rounded border border-sm shadow"
                    checked={selectedRows.includes(index)}
                    onChange={() => toggleRowSelection(index)}
                  />
                </td>

                <td className=" border relative w-[150px]">
                  {/* <Tooltip title={row.itemCode} arrow> */}
                  {/* <input
                    ref={rowInputRefs.current[row.id]}
                    autoComplete="off"
                    onFocus={(e) => { setCurrentF2ItemForSearchPopup(row); setShowDropdown(true) }}
                    type="text"
                    name="itemcode"
                    id={row.Lead_ID || row.id}
                    value={row.Prod_code || row.itemCode}
                    onChange={(e) =>
                      handleInputChange(row.id, "itemCode", e.target.value)
                    }
                    
                    placeholder="Enter Item Code"
                    // list={`itemCodes-${row.id}`} // Unique list for each row
                    className={`w-full border-none p-1 font-normal text-sm focus:outline-none focus:ring-0 ${row.itemCode?.length > 0
                      ? row.isSelectedItemCodeCorrect
                        ? "bg-transparent"
                        : "bg-red-400"
                      : "bg-transparent"
                      }  `}
                  // onFocus={() => setShowDropdown(true)}
                  // onBlur={() => console.log('clicked outside input')}
                  />

                  {currentProductEntryRowId === row.id &&
                    showDropdown &&
                    productData &&
                    row.itemCode?.length > 0 && (
                      <div
                        ref={dropdownRef}
                        style={{ width: "60rem" }}
                        className="absolute top-15 left-0 w-64 bg-gray-100 max-h-[300px] overflow-y-auto scrollbar-thin shadow-lg z-50 border border-gray-300"
                      >
                        {productData
                          ?.filter((product) => product.Code) // Filter matching products
                          ?.map((product, index) => (
                            <div
                              onClick={() => selectProduct(product.Code)}
                              key={index}
                              className="px-1 py-0.5 border bg-white hover:bg-gray-200"
                            >
                              <p className="font-semibold">{product.Code}</p>
                              <p className="text-xs text-gray-500">
                                {product.Description}
                              </p>
                              <div>
                                <span className={getStyleOfChip()}>
                                  Group: {product.Group}
                                </span>
                                <span className={getStyleOfChip()}>
                                  Subgroup: {product.Sgroup}
                                </span>
                                <span className={getStyleOfChip()}>
                                  Stock: {product.Stock}
                                </span>
                                <span className={getStyleOfChip()}>
                                  Ord Pending: {product.Ord_Pend}
                                </span>
                                <span className={getStyleOfChip()}>
                                  PO Pending: {product.Po_Pend}
                                </span>
                                <span className={getStyleOfChip()}>
                                  Selprice: {product.SelPrice}
                                </span>
                              </div>
                            </div>
                          ))}
                      </div>
                    )} */}

                  <Autocomplete
                    ListboxProps={{
                      onKeyDown: (e) => {
                        if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                          e.stopPropagation();
                        }
                      },
                    }}
                    // 1. DATA SOURCE
                    // Use productData, filtered by the parent component or search logic
                    options={productData || []}
                    // 2. KEY VALUE & LABEL
                    // Use 'Code' as the unique key and label for the options
                    ListboxComponent={TableListboxComponent} // Use the custom table container
                    getOptionLabel={(option) => option.Code || ""}
                    inputValue={row.Prod_code || row.itemCode}
                    // Since we are fetching from API, the API already filtered the results.
                    // MUI's internal filter often hides API results if they don't match exactly.
                    filterOptions={(x) => x}
                    // 4. VALUE HANDLING (What happens when an option is selected)
                    onChange={(event, newValue) => {
                      // newValue is the selected product object (or null if cleared)
                      if (newValue && newValue.Code) {
                        // Use your existing logic to update the row with the selected product
                        selectProduct(newValue.Code);

                        // focus goes to qty
                        setPendingQtyFocus(row.id); // 
                        
                      } else {
                        // If cleared, reset the item code
                        handleInputChange(
                          row.id,
                          "itemCode",
                          event.target.value
                        );
                      }
                      setHighlightedIndex(-1);
                    }}
                    // 5. INPUT TEXT HANDLING (As the user types)
                    onInputChange={(event, newInputValue, reason) => {
                      if (reason === "input") {
                        // Update the itemCode state in the parent form as the user types
                        handleInputChange(row.id, "itemCode", newInputValue);
                      }
                      setHighlightedIndex(-1);
                    }}
                    // 6. DEFAULT VALUE
                    // Ensure the Autocomplete displays the current row's item code
                    value={row.Prod_code || row.itemCode || null}
                    slotProps={{
                      paper: {
                        sx: {
                          width: containerRef.current
                            ? `calc(${containerRef.current.offsetWidth}px - 100px)`
                            : "auto", // Set this to the width of roughly 3 columns
                          marginLeft: 0, // Adjust alignment if necessary
                          boxShadow: 3,
                        },
                      },
                    }}
                    // 7. CUSTOM RENDERING (for the dropdown list items)
                    // call manoj sir's new api with pagination like athul ui
                    renderOption={(props, option, state) => {
                      const isHighlighted = state.index === highlightedIndex;

                      return (
                        <tr
                          {...props}
                          key={option.Code}
                          className={`border-b border-gray-50 cursor-pointer transition-colors ${
                            isHighlighted
                              ? "bg-blue-100 ring-2 ring-blue-400"
                              : "hover:bg-blue-50"
                          }`}
                          data-option-index={state.index}
                        >
                          <td className="p-2">
                            <div className=" text-gray-700">{option.Code}</div>
                          </td>
                          <td className="p-2">
                            <div className=" text-gray-700 truncate w-full">
                              {option.Description}
                            </div>
                          </td>
                          <td className="p-2 text-center  text-gray-600">
                            {option.Unit}
                          </td>
                          <td className="p-2 text-center  text-gray-600">
                            {option.Category}
                          </td>
                          <td className="p-2 text-center  text-gray-600">
                            {option.Ttl_Stk}
                          </td>
                          <td className="p-2 text-center  text-gray-600">
                            {option.Br_Stk}
                          </td>
                          <td className="p-2 text-center text-xs text-gray-600">
                            {option.Group}
                          </td>
                          <td className="p-2 text-center text-xs text-gray-600">
                            {option.Sgroup}
                          </td>
                          <td className="p-2 text-center  text-gray-600">
                            {option.SelPrice}
                          </td>
                        </tr>
                      );
                    }}
                    // 8. RENDER INPUT FIELD (where you attach the ref and styling)
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        // ⭐️ CRITICAL FIX: Attach the focus ref here
                        inputRef={rowInputRefs.current[row.id]}
                        onKeyDown={(e) => {
                          const optionsLength = productData?.length || 0;

                          // Handle Arrow Down - Navigate through dropdown
                          if (e.key === "ArrowDown") {
                            e.preventDefault();
                            e.stopPropagation();

                            e.nativeEvent.stopImmediatePropagation();

                            setHighlightedIndex((prev) => {
                              // If no selection, start at first item
                              if (prev === -1) return 0;
                              // Move to next item, wrap to first if at end
                              const next = prev + 1;
                              return next >= optionsLength ? 0 : next;
                            });
                          }

                          // Handle Arrow Up - Navigate backwards through dropdown
                          else if (e.key === "ArrowUp") {
                            e.preventDefault();
                            e.stopPropagation();

                            setHighlightedIndex((prev) => {
                              // If no selection, start at last item
                              if (prev === -1) return optionsLength - 1;
                              // Move to previous item, wrap to last if at beginning
                              const next = prev - 1;
                              return next < 0 ? optionsLength - 1 : next;
                            });
                          }

                          // Handle Enter - Select highlighted item or move to next field
                          else if (e.key === "Enter") {
                            e.preventDefault();

                            // If a row is highlighted, select it
                            if (
                              highlightedIndex >= 0 &&
                              productData?.[highlightedIndex]
                            ) {
                              selectProduct(productData[highlightedIndex].Code);
                              setHighlightedIndex(-1);
                              setPendingQtyFocus(row.id); // Move focus to quantity AFTER selection
                            } else {
                              // No highlight - move focus to Quantity input
                              if (qtyInputRefs.current[row.id]) {
                                qtyInputRefs.current[row.id].focus();
                                qtyInputRefs.current[row.id].select();
                              }
                            }
                          }

                          // Handle Escape - Clear highlight
                          else if (e.key === "Escape") {
                            setHighlightedIndex(-1);
                          }
                        }}
                        name="itemcode"
                        placeholder="Enter Item Code"
                        size="small"
                        // Apply your custom styling and error state
                        InputProps={{
                          ...params.InputProps,
                          // Hide MUI's default clear button and dropdown arrow if you prefer a cleaner look
                          endAdornment: null,
                          classes: {
                            input: `w-full border-none p-1 font-normal text-sm focus:outline-none focus:ring-0 ${
                              row.itemCode?.length > 0
                                ? row.isSelectedItemCodeCorrect
                                  ? "bg-transparent"
                                  : "bg-red-400"
                                : "bg-transparent"
                            }  `,
                          },
                        }}
                      />
                    )}
                    // 9. BEHAVIOR TWEAKS
                    selectOnFocus
                    clearOnBlur={false}
                    // Disable free solo if you only want selection from the list
                    freeSolo={true}
                    // This prop will manage the state for your `currentProductEntryRowId`
                    onFocus={() => {
                      setCurrentF2ItemForSearchPopup(row);
                      setHighlightedIndex(-1);
                    }}
                    onClose={() => {
                      setHighlightedIndex(-1);
                    }}
                  />
                </td>

                <Tooltip
                  title={row.Prod_Description || row.itemDescription}
                  arrow
                >
                  <td className=" border ">
                    <input
                      type="text"
                      id={row.Lead_ID || row.id}
                      value={row.Prod_Description || row.itemDescription}
                      onChange={(e) =>
                        handleInputChange(
                          row.id,
                          "itemDescription",
                          e.target.value
                        )
                      }
                      className="w-full p-1 border-none text-xs font-thin focus:outline-none focus:ring-0 text-left"
                    />
                  </td>
                </Tooltip>

                {/* <td className=" border w-[70px] text-center">
                  <input
                    type="text"
                    value={row.itemImage}
                    onChange={(e) =>
                      handleInputChange(row.id, "itemImage", e.target.value)
                    }
                    className="w-full p-1 border-none focus:outline-none focus:ring-0 text-center"
                  />
                </td> */}

                <td className="border w-[70px] text-center p-1">
                  <div className="flex justify-center items-center h-full">
                    {row.itemImage ? (
                      <img
                        src={fetchItemImage(
                          row.prod_imagepath || row.itemImage
                        )}
                        alt="Product"
                        className="w-6 h-6 object-cover rounded-md mx-auto"
                      />
                    ) : (
                      <img
                        // onClick={() => handleOpenModal(stock.CODE)}
                        src={notAllowedSymbol}
                        alt="Upload"
                        className="w-6 h-6 object-cover border rounded-md"
                      />
                    )}
                  </div>
                </td>

                <td className=" border w-[70px] text-center">
                  <input
                    type="text"
                    value={row.Prod_Unit || row.itemUnit}
                    onChange={(e) =>
                      handleInputChange(row.id, "itemUnit", e.target.value)
                    }
                    className="w-full p-1 border-none focus:outline-none focus:ring-0 text-center"
                  />
                </td>
                <td className=" border w-[80px] text-center">
                  {/* <input
                    type="text"
                    value={row.itemCurrentStock}
                    onChange={(e) =>
                      handleInputChange(
                        row.id,
                        "itemCurrentStock",
                        e.target.value
                      )
                    }
                    className="w-full p-1 border-none focus:outline-none focus:ring-0 text-center"
                  /> */}
                  {Number(row.itemCurrentStock) === 0 &&
                  row.itemCurrentStock != "" ? (
                    <div style={{ backgroundColor: "#f00", padding: "6px" }}>
                      {row.itemCurrentStock}
                    </div>
                  ) : (
                    <div style={{ backgroundColor: "#f7f7f7", padding: "6px" }}>
                      {row.itemCurrentStock}
                    </div>
                  )}
                </td>
                <td className=" border w-[40px]">
                  <input
                    min={0}
                    

                    ref={(el) => {
                      qtyInputRefs.current[row.id] = el;            // existing
                      if (qtyInputRefsFromParent)                   // ✅ ADD
                        qtyInputRefsFromParent.current[row.id] = el;// ✅ ADD
                    }}

                    type="number"
                    value={row.Prod_Qty || row.itemQuantity}
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) =>
                      handleInputChange(row.id, "itemQuantity", e.target.value)
                    }
                    className="w-full p-1 border-none focus:outline-none focus:ring-0 text-center"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault(); // Stop form submission
                        // Jump to the Price field of the SAME row
                        if (priceInputRefs.current[row.id]) {
                          priceInputRefs.current[row.id].focus();
                          priceInputRefs.current[row.id].select();
                        }
                      }
                    }}
                  />
                </td>
                <td className=" border w-[40px]">
                  <input
                    min={0}
                    type="number"
                    ref={(el) => (priceInputRefs.current[row.id] = el)}
                    value={row.Prod_Price || row.itemPrice}
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) =>
                      handleInputChange(row.id, "itemPrice", e.target.value)
                    }
                    className="w-full p-1 border-none focus:outline-none focus:ring-0 text-center"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault(); // Prevent default form behavior

                        // 1. Call the function to add a new row
                        handleAddRow(e);

                        // Note: The focus jump to the NEW row's Autocomplete
                        // is likely already handled by a useEffect in your
                        // allEntriesForm.js that watches the productEntries length.
                      }
                    }}
                  />
                </td>
                <td className=" border w-[30px] text-center">
                  <input
                    type="number"
                    value={
                      row.itemQuantity === ""
                        ? "-/-"
                        : row.Prod_Qty * row.Prod_Price ||
                          row.itemQuantity * row.itemPrice
                    }
                    readOnly
                    className="w-full p-0 border-none cursor-not-allowed focus:outline-none focus:ring-0 text-center"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="text-right gap-2">
          <button
            type="button"
            style={{ display: "inline-flex" }}
            className="px-3 py-1 text-xs font-medium text-white bg-green-600 rounded hover:bg-green-700 transition-colors mt-2"
            onClick={(e) => handleAddRow(e)}
          >
            <span>Add +</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductsInfo;
